/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultErrorLevel } from './ResultErrorLevel';
import {
    ResultErrorLevelFromJSON,
    ResultErrorLevelFromJSONTyped,
    ResultErrorLevelToJSON,
} from './ResultErrorLevel';

/**
 * 
 * @export
 * @interface ResultError
 */
export interface ResultError {
    /**
     * 
     * @type {string}
     * @memberof ResultError
     */
    readonly propertyName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultError
     */
    readonly hasPropertyName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultError
     */
    readonly errorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResultError
     */
    readonly errorMessage?: string | null;
    /**
     * 
     * @type {ResultErrorLevel}
     * @memberof ResultError
     */
    errorLevel?: ResultErrorLevel;
    /**
     * 
     * @type {any}
     * @memberof ResultError
     */
    readonly invalidValue?: any | null;
}

/**
 * Check if a given object implements the ResultError interface.
 */
export function instanceOfResultError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResultErrorFromJSON(json: any): ResultError {
    return ResultErrorFromJSONTyped(json, false);
}

export function ResultErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyName': !exists(json, 'propertyName') ? undefined : json['propertyName'],
        'hasPropertyName': !exists(json, 'hasPropertyName') ? undefined : json['hasPropertyName'],
        'errorCode': !exists(json, 'errorCode') ? undefined : json['errorCode'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'errorLevel': !exists(json, 'errorLevel') ? undefined : ResultErrorLevelFromJSON(json['errorLevel']),
        'invalidValue': !exists(json, 'invalidValue') ? undefined : json['invalidValue'],
    };
}

export function ResultErrorToJSON(value?: ResultError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errorLevel': ResultErrorLevelToJSON(value.errorLevel),
    };
}

